import { db } from "../../firebase";
import { addDoc, doc, getDoc, setDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const setSettings = async (newSettings) => {
  try {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "settings"
    );

    await setDoc(PropertyDynamicFieldsDoc, newSettings);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const CheckSettingsCollection = async () => {
  try {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "settings"
    );
    await getDoc(PropertyDynamicFieldsDoc);
  } catch (error) {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "settings"
    );
    await addDoc(PropertyDynamicFieldsDoc, {
      country: "Pakistan",
      currency: "PKR",
      currencyFormat: "verbal",
    });
    console.log(error);
    return false;
  }
};

export default setSettings;
